import React from "react";
import Tab from "@mui/material/Tab";

const DSTab = (props: React.ComponentProps<typeof Tab>) => {
  return <Tab {...props} />;
};

export default DSTab;
